import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { roomRateAvailabilityQueryKeys } from './roomRateAvailabilityQueryKeys';

export function useGetRoomRateLeadDays(
  propertyId: string | undefined,
  roomTypeId: string | undefined,
  roomRateId: string | undefined,
) {
  return useQuery<Array<App.RoomRateLeadDay>>({
    queryKey: [...roomRateAvailabilityQueryKeys.all, 'leadDays', propertyId ?? '', roomTypeId ?? '', roomRateId ?? ''],
    queryFn: async () =>
      (await ReservationService.getRoomRateLeadDays(propertyId, roomTypeId, roomRateId)).result?.dates ?? [],
    enabled: !!propertyId && !!roomTypeId && !!roomRateId,
  });
}
